import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { ProductoInterface } from "../../interfaces/productoInterfaces/Producto.interface";

export async function DeleteProductoAction (
    ProductoId: string
): Promise<ApiResponse<ProductoInterface>> {
   const {data} = await apiClient.delete(`gpProductos/${ProductoId}`);
    return {
        status: 200,
        data,
        message: "Producto eliminada correctamente",
    };
}
    